module.exports = __webpack_public_path__ + "static/uncanny-valley-a-memoir-71bc0c09d1822dfa1997400e961bc5b5.jpg";